const longpress = {
  bind: function (el, binding) {
    // 定义长按触发的回调函数
    const handler = binding.value;

    // 定义计时器变量
    let pressTimer = null;

    // 开始计时函数
    const start = (e) => {
      // 阻止默认行为（如移动端长按菜单）
      e.preventDefault();

      // 确保只有一个计时器运行
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // 执行长按回调，并传递原生事件对象
          handler(e);
        }, binding.arg || 800); // 默认800ms，可通过指令参数修改
      }
    };

    // 取消计时函数
    const cancel = () => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };

    // 存储事件处理函数，便于解绑时使用
    el._longPressHandlers = { start, cancel };

    // 绑定事件监听
    // 桌面端：mousedown（按下）和 mouseup（松开）
    // 移动端：touchstart（触摸开始）和 touchend（触摸结束）
    // 额外监听 click 和 touchcancel 确保意外操作时取消计时器。
    el.addEventListener("mousedown", start);
    el.addEventListener("touchstart", start);
    el.addEventListener("click", cancel);
    el.addEventListener("mouseup", cancel);
    el.addEventListener("touchend", cancel);
    el.addEventListener("touchcancel", cancel);
  },

  unbind: function (el) {
    // 解绑所有事件监听
    const { start, cancel } = el._longPressHandlers || {};
    if (start) {
      el.removeEventListener("mousedown", start);
      el.removeEventListener("touchstart", start);
    }
    if (cancel) {
      el.removeEventListener("click", cancel);
      el.removeEventListener("mouseup", cancel);
      el.removeEventListener("touchend", cancel);
      el.removeEventListener("touchcancel", cancel);
    }
  },
};
export default longpress;
